import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { VisibilityOutlined as ViewIcon } from '@mui/icons-material';
import { impersonationService } from '../../services/impersonationService';

/**
 * Fixed banner shown while a super-admin is "viewing as" another member. Makes the
 * impersonation impossible to miss (so nobody mistakes the target's view for their
 * own) and offers a one-click exit. Rendered at the top of AppLayout.
 */
export const ImpersonationBanner: React.FC = () => {
  const user = impersonationService.getUser();
  if (!impersonationService.isActive() || !user) return null;

  const label = user.name || user.email || 'member';

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: theme => theme.zIndex.modal + 100,
        bgcolor: 'error.main',
        color: 'error.contrastText',
        px: 2,
        py: 0.75,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1.5,
        boxShadow: 2,
      }}
    >
      <ViewIcon fontSize="small" />
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        Viewing as {label}
        {user.email && user.name ? ` (${user.email})` : ''}
      </Typography>
      <Button
        size="small"
        variant="contained"
        color="inherit"
        onClick={() => impersonationService.stop()}
        sx={{ color: 'error.main', bgcolor: '#fff', '&:hover': { bgcolor: '#f5f5f5' }, ml: 1 }}
      >
        Stop viewing
      </Button>
    </Box>
  );
};

export default ImpersonationBanner;
